import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { CardLayoutComponent } from '../shared/card-layout/card-layout.component';
import { Store } from '@ngrx/store';
import { globalMessages } from '../shared/global-messages';
import { FormattedValuePipe } from '../shared/pipes/formatted-value.pipe';

@Component({
    selector: 'app-contact-preferences',
    imports: [CardLayoutComponent],
    template: `
        <app-card-layout
            (click)="isActive = !isActive"
            [isActive]="isActive"
            title="Contact preferences"
            icon="contact-information"
            subtitle="Contact info"
            [isLoading]="isDCPolicyLoaded"
            [noDataMessage]="globalMessages.noDataAvailabelMsg"
            [failed]="dcPolicyFailed"
            [fields]="fields"
            (retry)="retryDCPolicy()"
        ></app-card-layout>
    `,
})
export class ContactPreferencesComponent {
    isActive = false;
    @Input() isDCPolicyLoaded = false;
    @Input() dcPolicyFailed = false;
    @Output() retry = new EventEmitter<void>();
    private store = inject(Store);
    policySignal = this.store.selectSignal((state: any) => state.policy);
    globalMessages = globalMessages;
    private formattedValuePipe = new FormattedValuePipe();

    // get fields(): { caption: string; value: string }[] {
    //     const policyState = this.policySignal();
    //     const policyNum = policyState.policyNumber;
    //     const snapshot = policyState.data?.[policyNum]?.policySnapshot;

    //     const data = policyState.data?.[policyNum]?.policySnapshot?.agencyInformation;
    //     if (!data) return [];

    //     const normalize = (val: any): string => {
    //         if (!val) return '';
    //         const v = String(val).trim().toLowerCase();
    //         return v === 'na' || v === 'null' || v === 'undefined' ? '' : String(val).trim();
    //     };

    //     const emails = data?.contactInfo?.emails ?? [];
    //     const phones = data?.contactInfo?.phones ?? [];
    //     const names = data?.contactInfo?.name ?? [];
    //     const maxLength = Math.max(emails.length, phones.length, names.length);

    //     const contacts: { caption: string; value: string }[] = [];
    //     for (let i = 0; i < maxLength; i++) {
    //         const email = normalize(emails[i]?.email?.value);
    //         const phone = normalize(phones[i]?.phone?.value);
    //         const name = normalize(names[i]?.name?.value);
    //         const value = `${email}${email && phone ? ' | ' : ''}${phone}`;
    //         if (name || value) contacts.push({ caption: name, value });
    //     }

    //     return [
    //         {
    //             caption: data?.enrolledInEDelivery?.node ?? 'Enrolled in e-delivery',
    //             value: data?.enrolledInEDelivery?.value ?? '-',
    //         },
    //         { caption: data?.mailingAddress?.node ?? 'Mailing address', value: data?.mailingAddress?.value ?? '-' },
    //         ...contacts,
    //     ].filter((f) => f.value && f.value !== 'N/A');
    // }

    get fields(): { caption: string; value: string }[] {
        const policyState = this.policySignal();
        const policyNum = policyState.policyNumber;
        const contactPrefs = policyState.data?.[policyNum]?.policySnapshot?.contactPreferences;
        if (!contactPrefs) return [];

        const policyInfo = policyState.data?.[policyNum]?.policySnapshot?.policyGeneralInformation;
        const contacts: { caption: string; value: string }[] = [];

        const eDelivery = policyInfo?.enrolledInEDelivery?.value;
        if (eDelivery) contacts.push({ caption: 'Enrolled in e-delivery', value: eDelivery });

        const insured = contactPrefs.insuredInformation;
        if (insured) {
            const mailingAddress =
                insured.mailingAddressDifferent?.value?.toLowerCase() === 'yes'
                    ? insured.mailingFullAddress?.value
                    : policyInfo?.propertyFullAddress?.value;

            if (mailingAddress) contacts.push({ caption: 'Mailing address', value: mailingAddress });
            // Extract co-owners dynamically (coOwner1, coOwner2, ...)

            const name = policyInfo?.name?.value || '';
            const email = insured.email?.value || '';
            const phone = insured.phone?.value || '';
            const contactValue = [email, this.formattedValuePipe.formatPhone(phone)].filter(Boolean).join(' | ');
            if (name || contactValue) contacts.push({ caption: name, value: contactValue });

            let i = 1;
            while (insured[`coOwner${i}Firstname`] || insured[`coOwner${i}Lastname`]) {
                const firstName = insured[`coOwner${i}Firstname`]?.value || '';
                const lastName = insured[`coOwner${i}Lastname`]?.value || '';
                const email = insured[`coOwner${i}Email`]?.value || '-';
                const phone = insured[`coOwner${i}Phone`]?.value || '-';
                const name = [firstName, lastName].filter(Boolean).join(' ');
                const contactValue = [email, this.formattedValuePipe.formatPhone(phone)].filter(Boolean).join(' | ');
                if (name || contactValue) contacts.push({ caption: name, value: contactValue });
                i++;
            }
        }

        const additionalInterests: any[] = contactPrefs.additionalInterest ?? [];
        additionalInterests.forEach((ai) => {
            const name = ai.name?.value || '';
            const email = ai.email?.value || '';
            const phone = ai.phone?.value || '';
            const contactValue = [email, this.formattedValuePipe.formatPhone(phone)].filter(Boolean).join(' | ');
            if (name || contactValue) contacts.push({ caption: name, value: contactValue });
        });

        const additionalNamedInsureds: any[] = contactPrefs.additionalNamedInsured ?? [];
        additionalNamedInsureds.forEach((ani) => {
            const name = [ani.firstName?.value, ani.lastName?.value].filter(Boolean).join(' ');
            const email = ani.email?.value || '';
            const phone = ani.phoneNumber?.value || '';
            const contactValue = [email, this.formattedValuePipe.formatPhone(phone)].filter(Boolean).join(' | ');
            if (name || contactValue) contacts.push({ caption: name, value: contactValue });
        });

        return contacts;
    }

    retryDCPolicy() {
        this.retry.emit();
    }
}
